import { SOPDTO } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useDefaultSOP(
  locationId: string,
  enabled = true,
  onSuccess?: (data: SOPDTO) => void
) {
  const search = new URLSearchParams();
  search.set('location_id', locationId);

  const url = `/v2/orm/sop/find?${search.toString()}`;
  const request = new Request(url);

  return useAuthenticatedRequest<SOPDTO>(request, {
    queryKey: ['sop', 'default', locationId],
    enabled,
    responseModifier: async (response) => {
      const respJson = await response.json();
      const sopResp = respJson.payload;

      try {
        const sopObj = JSON.parse(sopResp.sop_text);
        return {
          sop_workflow: sopObj.sop_workflow,
          id: sopResp.id,
          scan_sop: sopObj.scan_sop,
          alarm_type_id: sopResp.alarm_type_id,
        };
      } catch (error) {
        return {
          sop_text: sopResp.sop_text,
          id: sopResp.id,
          alarm_type_id: sopResp.alarm_type_id,
        };
      }
    },
    onSuccess,
  });
}

export default useDefaultSOP;
